import { Redirect } from 'expo-router';

export default function Enterprise() {
  // Enterprise is paused; keep existing links useful until it returns.
  return <Redirect href="/pricing" />;
}
